module.exports = __webpack_public_path__ + "media/video402.12399019.mp4";